const selectiveCourse = {
  path: 'selectiveCourse',
  component: resolve => require(['../../../../pages/user/course/selectivecourse'], resolve)
}

export default selectiveCourse



// WEBPACK FOOTER //
// ./src/router/user/course/selectivecourse/index.js